export default __webpack_public_path__ + "static/media/section2_7_mobile.3eb6f076.png";